// Crew Management page header - title, subtitle, export + add member buttons (Figma layout)
import React from 'react';
import { Download, Plus, QrCode } from 'lucide-react';

const CrewPageHeader = ({
  hasWriteRights,
  onExport,
  onAddMember,
  onQrCode,
}) => {
  return (
    <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-start sm:tw-items-center tw-justify-between tw-gap-4 tw-mb-8">
      {/* Left: Title + subtitle */}
      <div>
        <h1 className="tw-text-2xl tw-font-bold tw-text-gray-900 tw-m-0">
          Employee Management
        </h1>
        <p className="tw-text-sm tw-text-gray-500 tw-mt-1 tw-mb-0">
          Manage personnel, assignments, and medical compliance.
        </p>
      </div>

      {/* Right: QR + Export + Add Member */}
      <div className="tw-flex tw-items-center tw-gap-3">
        {hasWriteRights && onQrCode && (
          <button
            onClick={onQrCode}
            title="Self-register QR Code"
            className="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-text-sm tw-font-medium tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-shadow-sm tw-transition-colors"
          >
            <QrCode className="tw-w-4 tw-h-4" />
            QR Code
          </button>
        )}

        {hasWriteRights && (
          <button
            onClick={onExport}
            className="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-text-sm tw-font-medium tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-shadow-sm tw-transition-colors"
          >
            <Download className="tw-w-4 tw-h-4" />
            Export
          </button>
        )}

        {hasWriteRights && (
          <button
            onClick={onAddMember}
            className="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-indigo-600 hover:tw-bg-indigo-700 tw-text-white tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-shadow-sm tw-transition-colors tw-border-0"
          >
            <Plus className="tw-w-4 tw-h-4" />
            Add Employee
          </button>
        )}
      </div>
    </div>
  );
};

export default CrewPageHeader;
